import React from 'react';
import { Typography } from '@heycater/design-system';
import styled from 'styled-components';

type TypographyProps = React.ComponentProps<typeof Typography>;

export const FoodProgramH1 = (props: TypographyProps) => (
  <Typography
    variant="h1"
    lineHeight={{ xs: 1.5, md: 1.1 }}
    fontSize={{ xs: 40, md: 48 }}
    component="h1"
    {...props}
  />
);

export const FoodProgramH2 = styled((props: TypographyProps) => (
  <Typography component="h2" {...props} />
))`
  font-weight: 600;
  line-height: 1.6;
  font-size: 18px;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    font-size: 24px;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 36px;
    line-height: 1.5;
  }
`;
